import { GraphqlErrorReason } from '@ms/yammer-data/dist/api/types';

export const userProvisioningErrors = [GraphqlErrorReason.PendingUser, GraphqlErrorReason.UserNotMapped];
